import styled from "styled-components";
import { SmallButtonStyled, WrapperContainer } from "../../../../../components";
import { colors } from "../../../../../consts";

export const AdminRoleSettingsContainer = styled(WrapperContainer)`
  ${SmallButtonStyled} {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;

    height: 40px;
    padding: 0 16px;

    svg {
      path {
        fill: ${colors.ISABELLINE};
      }
    }
  }
`;
